import React from 'react';
import {useTranslation} from 'react-i18next';

// import { Container } from './styles';

function Acessorios({
    acessorio,
    linhaP,
    editarProposta,
    handleChildChange2 = () => {},
    aluguer,
}) {
    const {t} = useTranslation();
    function calculoTotalLinha() {
        var total = Number(acessorio?.preco) * Number(acessorio?.quantidade);
        var TotalCdesconto =
            total -
            total *
                Number(
                    acessorio?.descricao == null
                        ? 0
                        : acessorio?.descricao / 100,
                );
        if (TotalCdesconto.toString() == 'NaN') {
            TotalCdesconto = 0;
        }
        return TotalCdesconto?.toFixed(2);
    }

    return (
        <tr className="bg-gray-100 border-b border-white dark:bg-gray-600 dark:border-gray-700 ">
            <td className="text-right"></td>

            <td className="text-left ">
                <button
                    title={t('acessorios')}
                    type="button"
                    className="relative ml-3 inline-flex items-center font-bold p-1 text-xs  text-center cursor-pointer rounded-[5px] bg-blue-200 dark:bg-blue-400  text-blue-600 hover:text-blue-800 dark:text-blue-800 dark:hover:text-blue-600 ">
                    AC
                </button>
            </td>
            <td className="text-right"></td>
            <td className="px-6 "></td>
            <td className="px-6 ">{acessorio?.referencia}</td>
            <td className="px-6 ">{acessorio?.stock}</td>
            <td className="px-6 ">{acessorio?.encFornc}</td>
            {!aluguer && <td className="px-6 py-1"></td>}
            {/* <td className="px-6 py-1">
                <input
                    type="number"
                    placeholder="0"
                    defaultValue={acessorio?.quantidade || ""}
                    className="block w-full text-xs mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                    onChange={e => {
                        acessorio.quantidade = e.target.value;
                        handleChildChange2(acessorio);
                    }}
                    disabled={!editarProposta}
                />
            </td> */}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 py-1"></td>}
            {!aluguer && <td className="px-6 "></td>}
            {!aluguer && <td className="px-6 "></td>}
            <td className="px-6 "></td>
        </tr>
    );
}

export default Acessorios;
